import { handleActions } from '@housinganywhere/safe-redux';

import { Actions, ActionTypes } from './actions';
import { FeatureFlags } from './types';

export const initialState = {};

const reducer = handleActions<FeatureFlags, ActionTypes, Actions>(
  {
    [ActionTypes.SET]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  initialState,
);

export default reducer;
